import { render, staticRenderFns } from "./EmptyWishlist.vue?vue&type=template&id=55e61430&scoped=true&"
import script from "./EmptyWishlist.vue?vue&type=script&lang=ts&"
export * from "./EmptyWishlist.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyWishlist.vue?vue&type=style&index=0&id=55e61430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e61430",
  null
  
)

export default component.exports